<!--
 * @Author: huangxuejuan
 * @Date: 2026-09-01 10:00:00
 * @Description: 优享客户欢迎语卡片（content_metadata ai_agent_card_route=premium_welcome，语雀8.3）
 * 注：优享欢迎语默认走前端本地渲染（agent.vue 按日去重插入气泡），此组件为后台下发 route 时的兜底渲染；
 *     该卡片在 STANDALONE_CARD_ROUTES 中，独立成气泡展示（渐变描边），不与其他卡片/文案混排进白底消息框
-->
<script setup lang="ts">
import { computed } from "vue"
import type { CardPayload } from "@/types/app"

const props = defineProps<{
  card: CardPayload
}>()

const welcomeText = computed(
  () => props.card.data?.欢迎语 || "您好！尊贵的优享客户！我是您的专属支付助手AI嘉，请问有什么可以帮您？"
)
</script>

<template>
  <div class="premium-welcome-card">
    <div class="welcome-text">{{ welcomeText }}</div>
  </div>
</template>

<style scoped lang="scss">
.premium-welcome-card {
  max-width: 100%;
  border: 1px solid transparent;
  border-radius: 2px 15px 15px 15px;
  background:
    linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)) padding-box,
    linear-gradient(315deg, rgba(40, 141, 246, 1), rgba(125, 224, 221, 1)) border-box;
  box-shadow: 0px 0px 5px 0px rgba(74, 141, 255, 0.2);
}

.welcome-text {
  font-size: 15px;
  line-height: 1.6;
  color: #333333;
  word-break: break-word;
  border-radius: 2px 15px 15px 15px;
  background: #ffffff;
  padding: 12px 15px;
}
</style>
